import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalClose() {
  return <section className="py-24 bg-[#FAF7F2] text-[#0A0A0A] text-center" data-id="element-26">
      <div className="max-w-2xl mx-auto px-4" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-28">
          <p className="text-xl md:text-2xl font-serif mb-6 leading-relaxed" data-id="element-29">
            No sabes cuántos años más van a caminar juntos.
          </p>
          <p className="text-xl md:text-2xl font-serif mb-10 leading-relaxed" data-id="element-30">
            Pero sí sabes una cosa:{' '}
            <span className="italic text-[#B91C1C]" data-id="element-31">
              no quieres que esos años se vivan desde la distancia.
            </span>
          </p>

          <div className="w-16 h-1 bg-[#C5A55A] mx-auto mb-10" data-id="element-32"></div>

          <p className="text-lg text-[#555] mb-2" data-id="element-33">
            Si esta relación importa, si esta historia merece seguir creciendo,
            este no es un gasto.
          </p>
          <p className="text-2xl font-bold font-serif text-[#0A0A0A]" data-id="element-34">
            Es una elección.
          </p>
        </motion.div>
      </div>
    </section>;
}